import TasksUnblockedLinkController from "./tasks-unblock-link-controller";

export default class extends TasksUnblockedLinkController {
  connect() {
    super.connect();
    this.removeElement = this.removeElement.bind(this);
    App.Helpers.listenToCustomEvent(document, "task-unblock:success", this.removeElement);
  }

  removeElement(event) {
    const { id } = event.detail;
    if (id == this.taskID) {
      this.element.remove();
    }
  }
};



// WEBPACK FOOTER //
// ./app/components/tasks/assets/javascript/tasks-blocked-badge-link-controller.js